import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import ContactForm from './ContactForm';
import ContactInfo from './ContactInfo';
import SocialLinks from './SocialLinks';
import Footer from './Footer';

const Contact = ({ data }) => {
  return (
    <>
      <Box
        id="contact"
        sx={{
          py: { xs: 8, md: 12 },
          backgroundColor: '#0a0a0a',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("/Nuyu-media/Nuyu Pattern_1.png")',
            backgroundRepeat: 'repeat',
            opacity: 0.03,
          }}
        />

        <Container maxWidth="lg" sx={{ position: 'relative' }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={7}>
              <ContactForm />
            </Grid>
            <Grid item xs={12} md={5}>
              <ContactInfo data={data} />
            </Grid>
          </Grid>
          
          <SocialLinks data={data} />
        </Container>
      </Box>
      
      <Footer />
    </>
  );
};

export default Contact;
 